export const homepageUrl = "/";
